<template>
    <div class="related-link-item">
        <div class="related-link-item__content">
            <div class="related-link-item__link-row">
                <span class="related-link-item__icon">
                    <i class="fa-solid"
                       :class="iconClass"
                       aria-hidden="true"></i>
                </span>

                <div class="related-link-item__info">
                    <a :href="link.Url"
                       :target="link.OpenInNewWindow ? '_blank' : null"
                       :rel="link.OpenInNewWindow ? 'noopener' : null"
                       class="related-link-item__link">
                        {{ link.Text }}
                    </a>

                    <!--<div v-if="fileExtension"
                         class="related-link-item__extension">
                        {{ fileExtension.toUpperCase() }}
                    </div>-->

                    <div v-if="link.Description"
                         class="related-link-item__description">
                        {{ link.Description }}
                    </div>
                </div>
            </div>
        </div>

        <div v-if="$slots.actions"
             class="related-link-item__actions">
            <slot name="actions"
                  :link="link" />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { getLinkIcon } from './helpers';

    const props = defineProps({
        link: {
            type: Object,
            required: true
        }
    });

    // const fileExtension = computed(() => {
    //     const source = props.link.File?.FileName || props.link.Url;

    //     if (!source) return '';

    //     try {
    //         const clean = decodeURIComponent(source)
    //             .split('?')[0]
    //             .split('#')[0];

    //         const fileName = clean.split('/').pop();
    //         const index = fileName.lastIndexOf('.');

    //         if (index <= 0) return '';

    //         const extension = fileName.substring(index + 1).toLowerCase();

    //         return isKnownFileExtension(extension)
    //             ? extension
    //             : '';
    //     } catch {
    //         return '';
    //     }
    // });

    // const showExtension = computed(() => {
    //     if (!fileExtension.value) return false;

    //     const text = props.link.Text?.toLowerCase() || '';
    //     const extension = fileExtension.value.toLowerCase();

    //     return !text.includes(`(${extension})`) &&
    //         !text.includes(`[${extension}]`);
    // });

    const iconClass = computed(() => {
        const source = props.link.File?.FileName || props.link.Url;

        return getLinkIcon(source);
    });

    // function isKnownFileExtension(extension) {
    //     return [
    //         'pdf',
    //         'doc',
    //         'docx',
    //         'xls',
    //         'xlsx',
    //         'csv',
    //         'ppt',
    //         'pptx',
    //         'txt',
    //         'rtf',
    //         'jpg',
    //         'jpeg',
    //         'png',
    //         'gif',
    //         'webp',
    //         'svg',
    //         'zip',
    //         'rar',
    //         '7z'
    //     ].includes(extension);
    // }
</script>